import axios from 'axios'
import { Indicator } from 'mint-ui';
import { Toast } from 'vant';
const service = axios.create({
    // baseURL: "http://dev.api.hkaspire.net:21650/",
    // baseURL: "http://192.168.80.52/",
    // baseURL: "https://test.hkaspire.net/",
    // baseURL: "http://192.168.80.20/",

    baseURL: 'https://app.hkaspire.cn/', //线上
    timeout: 60000
});

service.interceptors.request.use(
    config => {
        Indicator.open('加载中...');
        if(sessionStorage.getItem('token')){    
            config.headers.Authorization = sessionStorage.getItem('token')
  
        }
        if (sessionStorage.getItem('t')) {
          // 判断是否存在token，如果存在的话，则每个http header都加上token
          // config.headers.Authorization = JSON.parse(des.decryptByDES(sessionStorage.getItem('tokentwo'),d)).token;
            config.headers.ContentAu = sessionStorage.getItem('t')
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// 请求响应
service.interceptors.response.use(
	(response) => {
		Indicator.close();
		return response;
	},
	(error) => {
		Indicator.close();
        if (error.message === 'Request failed with status code 500' || error.message === 'Request failed with status code 400') {
            Toast(error.response.data || error.message)
            // Dialog.confirm({
            //     message: error.response.data.message || error.message,
            //     confirmButtonColor: '#222222',
            //     showCancelButton: false
            // })
            // .then(() => {
            //     // on confirm
            // })
            // .catch(() => {
            //     // on cancel
            // });
        } else if (error.message === 'Request failed with status code 401') {
            Toast(error.response.data || error.message)
            // Dialog.confirm({
            //     message: error.response.data || error.message,
            //     confirmButtonColor: '#222222',
            //     showCancelButton: false
            // })
            // .then(() => {
            //     // on confirm
            // })
            // .catch(() => {
            //     // on cancel
            // });
        }
		return Promise.reject(error); // 返回接口返回的错误信息
	}
);

class http{
    static post(url,data){
        return new Promise(function(resolve,reject){
            service.post(url,data).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }

    static get(url){
        return new Promise(function(resolve,reject){
            service.get(url).then(res=>{
                resolve(res.data)
            }).catch(err=>{
                reject(err)
            })
        })
    }

    // 移动端弹出层滚动不影响body
    static divScroll(layerNode){
        if(!document.querySelector(layerNode)) return;
        this.popupLayer=document.querySelector(layerNode);
        this.startX=0;
        this.startY=0;
        this.popupLayer.addEventListener('touchstart',function(e){
            this.startX=e.changedTouches[0].pageX;
            this.startY=e.changedTouches[0].pageY;
        },false);

        this.popupLayer.addEventListener('touchmove',function(e){
            e.stopPropagation();
            var deltaX=e.changedTouches[0].pageX-this.startX;
            var deltaY=e.changedTouches[0].pageY-this.startY;
            if(Math.abs(deltaY)<Math.abs(deltaX)){
                e.preventDefault();
                return false;
            }
            if(this.offsetHeight+this.scrollTop>=this.scrollHeight){
                if(deltaY<0){
                    e.preventDefault();
                    return false;
                }
            }
            if(this.scrollTop === 0){
                if(deltaY > 0) {
                    e.preventDefault();
                    return false;
                }
            }
        },false);
    }
    static upload(file){
       return new Promise(function (resolve, reject) {	
     		service.post('external/public/upload_files?fn=' + file.name, file).then((res) => {
						if (res.data.ok === true) {
							resolve(res.data.data);
						} else {
							Toast({
								message: '权限不足',
								position: 'middle',
								duration: 2000
							});
						}
					})
					.catch((err) => {
						// if (err.response.status === 401) {
						// 	Toast({
						// 		message: '权限不足',
						// 		position: 'middle',
						// 		duration: 2000
						// 	});
						// } else {
							
						// }
                        reject(err);
					});
                })
   
    }


    //    * OSS上传文件（适配你的http封装，带完整进度条）
    //  * @param {File} file 要上传的文件
    //  * @param {String} pt 上传路径标识
    //  * @param {Function} onProgress 进度回调函数，参数：{ percent: 数字(0-100), msg: 字符串 }
    //  * @returns {Promise<String>} 上传后的OSS文件URL
    //  */
    static newUploadOss(file, pt, onProgress) {
        const self = this;
        const progressCallback = onProgress || function() {};
        
        const ossAxios = axios.create({
            timeout: 300000,
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        return new Promise(function(resolve, reject) {
            let timer = null;
            let simulatePercent = 0;
            let isRealProgress = false;

            const initProgress = () => {
                simulatePercent = 1;
                progressCallback({ percent: simulatePercent, msg: '初始化上传...' });
                timer = setInterval(() => {
                    if (simulatePercent < 10) {
                        simulatePercent += 1;
                        progressCallback({ percent: simulatePercent, msg: '获取上传凭证中...' });
                    }
                }, 200);
            };

            const updateRealProgress = (percent, msg = '') => {
                if (timer) { clearInterval(timer); timer = null; }
                isRealProgress = true;
                simulatePercent = percent;
                progressCallback({ 
                    percent: Math.min(99, simulatePercent), 
                    msg: msg || `上传中 ${simulatePercent}%` 
                });
            };

            const completeProgress = () => {
                if (timer) clearInterval(timer);
                progressCallback({ percent: 100, msg: '上传完成' });
            };

            const handleFail = (errMsg) => {
                if (timer) clearInterval(timer);
                progressCallback({ percent: 0, msg: errMsg });
                reject(new Error(errMsg));
            };

            initProgress();

            self.get(`article/public/uploadsignature?path=${pt}`).then(signRes => {
                if (!signRes || !signRes.host || !signRes.accessid) {
                    return handleFail('获取OSS上传凭证失败');
                }

                updateRealProgress(10, '上传凭证获取成功，开始上传文件...');

                const ossParams = signRes;
                const fileName = ossParams.dir + ossParams.filename + file.name.replace(/.+\./, '.');
                const formData = new FormData();
                
                formData.append('OSSAccessKeyId', ossParams.accessid);
                formData.append('policy', ossParams.policy);
                formData.append('Signature', ossParams.signature);
                formData.append('key', fileName);
                formData.append('success_action_status', '200');
                formData.append('file', file);

                ossAxios.post(ossParams.host, formData, {
                    onUploadProgress: (e) => {
                        if (e.lengthComputable) {
                            const uploadPercent = 10 + Math.round((e.loaded / e.total) * 90);
                            updateRealProgress(uploadPercent);
                        }
                    }
                }).then(() => {
                    completeProgress();
                    resolve(`${ossParams.host}/${fileName}`);
                }).catch(ossErr => {
                    handleFail(`文件上传失败：${ossErr.message || '网络错误'}`);
                });

            }).catch(signErr => {
                handleFail(`获取上传凭证失败：${signErr.message || '权限不足'}`);
            });
        });
    }
    

    
}

export default http;
